// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.splash-screen {
  width: 100%;
  height: 100%;
  gap: 72px;
}
.splash-screen__logo {
  display: block;
  width: 230px;
  max-width: 100%;
  height: auto;
  overflow: visible;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/components/splash/SplashScreen.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,SAAA;AACF;AACE;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AACJ","sourcesContent":[".splash-screen {\n  width: 100%;\n  height: 100%;\n  gap: 72px;\n\n  &__logo {\n    display: block;\n    width: 230px;\n    max-width: 100%;\n    height: auto;\n    overflow: visible;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
